import React, { FC } from 'react';
import styled from 'lib/styled';
import { colors, Colors } from '../Shared/Style/colors';
import { ThemeType } from '@app/api/models/Theme';
import { useTheme } from 'emotion-theming';

export type Props = {
    width?: number;
    margin?: string;
    color?: Colors;
};

const StyledDivider = styled.div(({ width = 90, margin = '16px 0px', color, theme }: Props & { theme: ThemeType }) => {
    return {
        borderTop: `1px solid ${
            color ? theme?.colors?.[color] || colors[color] : theme?.colors?.divider || colors.divider
        }`,
        margin,
        width: `${width}%`,
    };
});

const DividerContainer = styled.div(() => {
    return {
        display: 'grid',
        placeItems: 'center',
    };
});

const Divider: FC<Props> = ({ width, margin, color, ...rest }) => {
    const theme = useTheme<ThemeType>();
    return (
        <DividerContainer {...rest}>
            <StyledDivider theme={theme} margin={margin} width={width} color={color} />
        </DividerContainer>
    );
};

export default Divider;
